import { Links } from "../types";
import routeIcons from "../components/icons";

const mainSidebarItems: Links = {
  Dashboard: {
    type: "Page",
    open: false,
    route: "dashboard",
    permission: "DASHBOARD_READ",
    subPages: [],
    icon: routeIcons.dashboard,
  },
  Customer: {
    type: "Menu",
    open: false,
    route: "customer",
    permission: "CUSTOMER_MENU_READ",
    subPages: [
      {
        title: "Companies",
        route: "companies",
        permission: "COMPANIES_READ",
      },
      {
        title: "Addresses",
        route: "addresses",
        permission: "ADDRESSES_READ",
      },
      {
        title: "Contacts",
        route: "contacts",
        permission: "CONTACTS_READ",
      },
      {
        title: "Contract Management",
        route: "contract",
        permission: "CONTRACT_MANAGEMENT_READ",
      },
    ],
    icon: routeIcons.customers,
  },
  Projects: {
    type: "Menu",
    open: false,
    route: "projects",
    permission: "PROJECTS_MENU_READ",
    subPages: [
      {
        title: "Projects",
        route: "projects",
        permission: "PROJECTS_READ",
      },
      // { title: "Project Calendar", route: "project-calendar", permission: "PROJECT_CALENDAR_READ" },
      { title: "Vendor Management", route: "vendors", permission: "VENDOR_MANAGEMENT_READ" },
    ],
    icon: routeIcons.projects,
  },
  Operations: {
    type: "Menu",
    open: false,
    route: "operations",
    permission: "OPERATIONS_MENU_READ",
    subPages: [
      { title: "Incoming Shipments", route: "incoming-shipments", permission: "INCOMING_SHIPMENTS_READ" },
      { title: "Sort", route: "sort", permission: "SORT_READ" },
      { title: "Assets", route: "assets", permission: "ASSETS_READ" },
      { title: "Audit a Location", route: "audit-a-location", permission: "AUDIT_A_LOCATION_READ" },
      { title: "Master Items", route: "master-items", permission: "MASTER_ITEMS_READ" },
      { title: "Locations", route: "locations", permission: "LOCATIONS_READ" },
    ],
    icon: routeIcons.operations,
  },
  "Enterprise Solutions": {
    type: "Menu",
    open: false,
    route: "enterprise-solutions",
    permission: "ENTERPRISE_SOLUTIONS_MENU_READ",
    subPages: [{ title: "Distribution Center", route: "distribution-center", permission: "DISTRIBUTION_CENTER_READ" }],
    icon: routeIcons.enterpriseSolutions,
  },
  Techs: {
    type: "Menu",
    open: false,
    route: "techs",
    permission: "TECHS_MENU_READ",
    subPages: [{ title: "Tech Activity", route: "tech-activity", permission: "TECH_ACTIVITY_READ" }],
    icon: routeIcons.techs,
  },
  Sales: {
    type: "Menu",
    open: false,
    route: "sales",
    permission: "SALES_MENU_READ",
    subPages: [
      // { title: "FMVs", route: "fmvs", permission: "FMVS_READ" },
      // { title: "Quotes", route: "quotes", permission: "QUOTES_READ" },
      { title: "Sales Orders", route: "sales-orders", permission: "SALES_ORDERS_READ" },
      { title: "Returns", route: "returns", permission: "RETURNS_READ" },
    ],
    icon: routeIcons.sales,
  },
  Finance: {
    type: "Menu",
    open: false,
    route: "finance",
    permission: "FINANCE_MENU_READ",
    subPages: [{ title: "Purchase Orders", route: "purchase-orders", permission: "PURCHASE_ORDERS_READ" }],
    icon: routeIcons.finance,
  },
  Reports: {
    type: "Menu",
    open: false,
    route: "reports",
    permission: "REPORTS_MENU_READ",
    subPages: [
      { title: "Custom Reports", route: "custom-reports", permission: "CUSTOM_REPORTS_READ" },
      { title: "Pre-Built Reports", route: "pre-built-reports", permission: "CUSTOM_REPORTS_READ" },
    ],
    icon: routeIcons.reports,
  },
};

export default mainSidebarItems;
